<div>
	<div class="col-sm-6 col-md-6">
		<h4>
			{{"iotemeter.site.usage_report" | translate }}
		</h4>
	</div>

	<ng-container>
		<div class="d-flex flex-wrap justify-content-between py-4">
			<div class="d-flex justify-content-start col-8 align-items-center">
				<div class="col-3">
					<label class="mr-2">{{'g.select_year' | translate}}</label>
					<ng-select
						[searchable]="false"
						[items]="yearsOption"
						bindLabel="label"
						placeholder="{{'g.select_year' | translate}}"
						name="year"
						[(ngModel)]="selectedYearUsageReport"
						(ngModelChange)="selectQuarter(quartersOption[0])"
						[clearable]="false"
					></ng-select>
				</div>

				<div class="col-3">
					<label class="mx-2">{{'g.select_quarter' | translate}}</label>
					<ng-select
						[searchable]="false"
						[items]="quartersOption"
						bindLabel="label"
						placeholder="{{'g.select_quarter' | translate}}"
						name="quarter"
						[(ngModel)]="selectedQuarterUsageReport"
						(ngModelChange)="updateSelectedQuarter()"
						[clearable]="false"
					></ng-select>
				</div>
			</div>
		</div>

		<div class="mt-4">
			<ul class="list-group">
				<li class="list-group-item">
					<span>
						<strong>
							{{'iotemeter.devices.total_billed_kwhrs' | translate}}:
						</strong>
						{{deviceService.getBilledKWHRsValueAndUnit(selectedQuarterUsageReportData?.total_KWHRS)}}
					</span>
				</li>
				<li class="list-group-item">
					<span>
						<strong>
							{{'iotemeter.devices.daily_billed_kwhrs' | translate}}:
						</strong>
						{{(selectedQuarterUsageReportData?.daily_KWHRS || 0).toFixed(2)}}
					</span>
				</li>
				<li class="list-group-item">
					<span>
						<strong>
							{{'iotemeter.devices.total_usage_time' | translate}}:
						</strong>
						{{ this.commonService.convertSecondsToHoursMinsSecs(selectedQuarterUsageReportData?.total_consumed_usage_time || 0) }}
					</span>
				</li>
			</ul>
		</div>
	</ng-container>

	<sct-custom-table
		[columnsConfig]="imUsageReportTableConfig.column"
		[data]="imUsageReportTableConfig.data"
		[config]="imUsageReportTableConfig.config"
	>
	</sct-custom-table>
</div>